import { z } from "zod";
import { BackdropSchema } from "../Backdrop";
import { LinkItemSchema } from "../LinkItem";
import { MediaSchema, VisualMediaSchema } from "../Media";
import { RichTextSchema } from "../RichText";
export const MediaPromoItemSchema = z.object({
    backdrop: BackdropSchema.optional(),
    media: MediaSchema.optional(),
    supertitle: z.string().optional(),
    title: z.string().optional(),
    subtitle: z.string().optional(),
    description: RichTextSchema.optional(),
    links: z.array(LinkItemSchema).optional(),
    product: z
        .object({
        title: z.string().optional(),
        machineName: z.string().optional(),
        id: z.string().optional(),
        media: VisualMediaSchema.optional(),
    })
        .optional(),
    category: z
        .object({
        machineName: z.string(),
        title: z.string(),
    })
        .optional(),
});
//# sourceMappingURL=index.js.map